<script>
  import Section from './comp/section.svelte';
  import CenterDesc from './comp/center-desc.svelte';
  import VerticalSpacing from './comp/vertical-spacing.svelte';
  import PriceCalc from './comp/price-calculator.svelte';
  const dataCreater = (idKor, idEn, descMain, descSub) => {
    return {
      idKor: idKor,
      idEn: idEn,
      descMain: descMain,
      descSub: descSub,
    };
  };
  const data = dataCreater(
    '가격표',
    'Pricings',
    ['준비된 즐거움,', '합리적인 가격으로부터'],
    [
      '기대 이상을 선사하는 합리적인 가격으로',
      '여러분의 빛나는 시간을 아낌없이 응원해요.',
    ]
  );
  const centerData1 = {
    centerDesc: ['가격 계산기', '세부사항은 상세 가격표를 참조해주세요.'],
  };
  const centerData2 = { centerDesc: ['상세 가격표', '4인 기준'] };
</script>

<section class="container">
  <Section {...data} />
  <VerticalSpacing marginTop="130" />
  <CenterDesc {...centerData1} />
  <VerticalSpacing marginTop="50" />
  <PriceCalc />
  <VerticalSpacing marginTop="130" />
  <CenterDesc {...centerData2} />
  <VerticalSpacing marginTop="80" />
  <article class="price-grid">
    <div class="price-item-wrapper">
      <div class="price-item-type">2시간</div>
      <div class="price-item-type-detail" />
      <div class="price-item-type-detail for-pc" />
      <div class="price-item-value">2만원</div>
    </div>
    <div class="price-item-wrapper">
      <div class="price-item-type">추가인원 당</div>
      <div class="price-item-type-detail" />
      <div class="price-item-type-detail for-pc" />
      <div class="price-item-value">5천원</div>
    </div>
    <div class="price-item-wrapper">
      <div class="price-item-type">종일권</div>
      <div class="price-item-type-detail">오전10시 - 오후10시</div>
      <div class="price-item-type-detail for-pc" />
      <div class="price-item-value">10만원</div>
    </div>
    <div class="price-item-wrapper">
      <div class="price-item-type">야간권</div>
      <div class="price-item-type-detail">오후10시 - 오전10시</div>
      <div class="price-item-type-detail for-pc" />
      <div class="price-item-value">5만원</div>
    </div>
  </article>
  <VerticalSpacing marginTop="30" />
  <article class="price-details">
    <!-- <div class="equipment-type">특수장비 대여료 :</div> -->
    <div class="price-equipment">* 음향장비 대여료 별도 (1만원)</div>
    - 5인부터 1인당 추가요금 5천원이 추가됩니다.<br />
    - 종일권과 야간권은 인원제한이 없습니다.<br />
    <div style="margin-bottom:10px;" />
    예시) 4시간 6인 : 4만원 + 1만원 = 5만원
  </article>

  <VerticalSpacing marginTop="150" />
</section>

<style>
  .container {
    width: 64%;
    margin: 0 auto;
  }

  .price-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 0;
  }

  .price-item-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
  }

  .price-item-wrapper:nth-child(odd)::after {
    content: '';
    display: inline;
    position: absolute;
    top: 25%;
    right: 0;
    height: 50%;
    border-right: 1px solid black;
  }

  .price-item-type,
  .price-item-type-detail,
  .price-item-value {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .price-item-type {
    flex: 2;
    font-weight: 200;
    font-size: 30px;
    margin: 0;
  }

  .price-item-type-detail {
    text-align: center;
    font-weight: 200;
    font-size: 20px;
    /* margin-bottom: 20px; */
    flex: 1;
  }

  .price-item-value {
    font-weight: 500;
    font-size: 64px;
    margin: 0;
    /* margin-top: 50px; */
    flex: 5;
  }

  .equipment-type {
    font-weight: 400;
    font-size: 30px;
    margin: 0;
    margin-bottom: 12px;
  }

  .price-equipment {
    font-weight: 200;
    font-size: 26px;
    margin: 0;
    text-align: center;
    margin-bottom: 25px;
  }

  .price-details {
    width: 50%;
    margin: 0 auto;
    font-size: 24px;
  }

  @media screen and (max-width: 1300px) {
    .container {
      width: 90%;
    }
    .price-item-value {
      font-size: 54px;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 96%;
      margin: 0 auto;
    }

    .price-grid {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      row-gap: 30px;
    }

    .price-item-value {
      font-weight: 500;
      font-size: 48px;
      margin: 0;
      /* margin-top: 20px; */
    }

    .price-item-type {
      margin: 0;
    }

    .price-item-type-detail {
      text-align: center;
      font-weight: 200;
      font-size: 4vw;
      /* margin-bottom: 20px; */
    }
    .price-item-value {
      flex: 4;
    }
    .price-item-type-detail.for-pc {
      flex: 0;
    }

    .price-equipment {
      font-size: 5vw;
    }

    .price-details {
      width: 100%;
      margin: 0;
      font-size: 4.5vw;
    }
  }
</style>
